<template>
  <div class="search-box">
    <form @submit.prevent="handleSearch" class="flex items-center">
      <input
        type="text"
        v-model="searchQuery"
        :placeholder="$t('interface.search.placeholder')"
        class="search-input"
      />
      <button type="submit" class="search-button" :title="$t('interface.search.button')">
        <i class="fas fa-search"></i>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  data() {
    return {
      searchQuery: ''
    }
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        // 添加Google Analytics事件跟踪
        if (window.gtag) {
          window.gtag('event', 'search', {
            'event_category': 'Search',
            'event_label': this.searchQuery
          });
        }
        this.$router.push(`/search/${this.searchQuery}`);
        this.searchQuery = '';
      }
    }
  }
}
</script>

<style scoped>
.search-box {
  position: relative;
}

.search-input {
  width: 200px;
  padding: 0.45rem 2.5rem 0.45rem 1rem;
  border: 1px solid rgba(212, 207, 200, 0.25);
  border-radius: 4px;
  background: transparent;
  color: #f5f5f5;
  font-size: 0.85rem;
  font-family: var(--font-sans, -apple-system, system-ui, "PingFang SC", sans-serif);
  transition: border-color 0.3s ease, width 0.3s ease;
}

.search-input::placeholder {
  color: rgba(212, 207, 200, 0.55);
}

.search-input:focus {
  width: 240px;
  background: transparent;
  outline: none;
  border-color: var(--brass, #b39a6b);
}

.search-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(212, 207, 200, 0.6);
  cursor: pointer;
  padding: 5px;
  transition: color 0.3s ease;
}

.search-button:hover {
  color: var(--brass, #b39a6b);
}
</style>